import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import BackOrderList from '../entities/order-back-list'
import createdata from '@/store/entities/create-order'
import UpdateBackOrderStatu from '@/store/entities/back-order-update-statu'

interface BackOrderState extends ListState<BackOrderList> {
    orderInfo: createdata,
    updateOrdeData: UpdateBackOrderStatu,
}

class BackOrderMutations extends ListMutations<BackOrderList>{

}
class BackOrder extends ListModule<BackOrderState, any, BackOrderList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BackOrderList>(),
        loading: false,
        updateOrdeData: null,
        ids: [],
        BaseSkuNums : 0,
        ordertype:0
    }
    actions = {
        async getAll(context: ActionContext<BackOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/BackOrder/GetOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<BackOrderList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getOrder(context: ActionContext<BackOrderState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/BackOrder/GetOrderInfo', { params: payload.data });
            context.state.orderInfo = (reponse.data.result as createdata);
        },
        async updateOrderStatus(context: ActionContext<BackOrderState, any>, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/ProcesOrderStatu', payload.data);
        },
        async cancelOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/CancelOrder?id=' + payload.data.id);
        },
        async updatePackageStatus(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/ProcessOrderPackageStatus', payload.data);
        },
        async updatePackedStatus(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/WarehouseOrderPacked', payload.data);
        },
        async arriveWarehouse(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/arriveWarehouse?tradeNo=' + payload.data.tradeNo);
        },
        async commodityWeigh(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/CommodityWeigh?tradeNo=' + payload.data.tradeNo + '&resultWeight=' + payload.data.resultWeight);
        },
        async oneClickDelivery(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/BackOrder/OneClickDelivery');
        }
    };
    mutations = {
        setCurrentPage(state: BackOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackOrderState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const backOrder = new BackOrder();
export default backOrder;